import { Link } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import { useState } from 'react';
// import logoBlack from "../../assets/gt-home logo.svg";
import logoBlack from "../../assets/logo.svg";


function NavEn({ url }) {
  const [open, setOpen] = useState(false);

  const handelClick = () => {
    setOpen(!open);
  };

  return (
    <nav style={{ direction: "rtl" }}>
      <div className="nav-logo">
        <img src={logoBlack} className="app-logo" alt="logo" />
      </div>

      <div className="nav-bottom" onClick={handelClick}>
        <FaBars />
      </div>

      {open && (
        <div className="nav-content">
          <Link to="/ar" onClick={handelClick}>
            الرئيسية
          </Link>
          <Link to="/ar/projects" onClick={handelClick}>
            المشاريع
          </Link>
          <Link to="/ar/properties" onClick={handelClick}>
            العقارات
          </Link>
          {/* <a href="/#contact-sec" onClick={handelClick}>
            Contact
          </a> */}
          <Link to="/ar/#contact-sec" onClick={handelClick}>
            اتصال
          </Link>
          <Link className="lang" to={url} onClick={handelClick}>
            EN
          </Link>
        </div>
      )}

      <div className="long-nav">
          <Link to="/ar">
            الرئيسية
          </Link>
          <Link to="/ar/projects">
          المشاريع
          </Link>
          <Link to="/ar/properties">
          العقارات
          </Link>
          <Link to="/ar/#contact-sec">
            اتصال
          </Link>
          <Link className="lang" to={url}>
            EN
          </Link>
      </div>
    </nav>
  );
}

export default NavEn;
